import {useRequiredConfig} from '@domain/shifthandover'
import {DateRange, ShiftQuickSelectSlots} from '@hconnect/common/types'
import {getQuickSelectFilter} from '@hconnect/common/utils'
import {useUpmPlantNow} from '@hconnect/upm'
import {isString} from 'lodash'
import {Moment} from 'moment-timezone'

import {useTimeRangeParam} from './useTimeRangeParam'

type OptimizationSpecialistTimeRangeResult = {
  plantId: string
  start?: Moment
  end?: Moment
  rawTimeRange: DateRange | ShiftQuickSelectSlots
}

export const useOptimizationSpecialistTimeRange = (
  plantId: string
): OptimizationSpecialistTimeRangeResult => {
  const {shifts, timezone} = useRequiredConfig(plantId)
  const {timeRange} = useTimeRangeParam({
    defaultTimeRange: 'pastShift',
    key: 'timeRange',
    timezone: timezone
  })

  const getPlantNow = useUpmPlantNow(plantId)

  const isQuickSelectSlots = isString(timeRange)
  if (isQuickSelectSlots) {
    const timeRangeSelectSlot = timeRange
    const [startDate, endDate] = getQuickSelectFilter(timeRangeSelectSlot, shifts, getPlantNow())

    return {
      plantId,
      start: startDate,
      end: endDate,
      rawTimeRange: timeRangeSelectSlot
    }
  }

  const {startDate, endDate}: DateRange = timeRange
  return {
    plantId,
    start: startDate,
    end: endDate,
    rawTimeRange: timeRange
  }
}
